import { atom } from 'jotai'

export type ActiveMidGuide = string | null

export const INITIAL_ACTIVE_MID_GUIDE: ActiveMidGuide = null
// 주제별 암정보 상세 페이지의 활성화 된 중분류 아이디 & 소분류 인덱스
export const activeMidGuideAtom = atom<ActiveMidGuide>(INITIAL_ACTIVE_MID_GUIDE)
